import React from 'react'
import FirebaseContext from "../../firebase/context";

import {
    Container,
    Paper,
    Grid,
    Breadcrumbs,
    Typography,
} from "@material-ui/core";
import { Link, withRouter } from 'react-router-dom';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CompCursoItem from '../components/CompCursoItem';
import UsuarioContext from '../contex/UsuarioContext';

const style = {
    cardGrid: {
        paddingTop: 8,
        paddingBottom: 8
    },
    paper: {
        backgroundColor: "#f5f5f5",
        padding: "20px",
        minHeight: 650
    },
    link: {
        // display: "flex",
        textDecoration: "none"
    },
    gridTextfield: {
        marginTop: "20px"
    },
    card: {
        height: "100%",
        display: "flex",
        flexDirection: "column"

    },
    cardMedia: {
        paddingTop: "56.25%"
    },
    cardContent: {
        flexGrow: 1
    },
    barraBoton: {
        marginTop: "10px"
    }
};

const PagListaCursos = (props) => {

    const { firebase, user } = React.useContext(FirebaseContext);
    const [cursos, setCursos] = React.useState([]);
    const idCiclo = props.match.params.cicloId;
    
     ////////////////////////////////////////////////////////////////////  
    //  const usuarioContextLocal = React.useContext(UsuarioContext);
    //  const { setObjUsuario } = usuarioContextLocal;
     
    //  React.useEffect(() => {
    //      firebase.db.collection("colUsuarios").where("id", "==", user.uid).get().then(snapshot => {
    //          const arrayUsuario = snapshot.docs.map(doc => {
    //              let data = doc.data();
    //              let id = doc.id;
    //              return { id, ...data };
    //          });            
    //          setObjUsuario(arrayUsuario[0]);  
    //      });
    //  }, [])
 ///////////////////////////////////////////////////////////////////////////

    React.useEffect(() => {
        getCursos();
    }, []);

    function getCursos() {
        firebase.db.collection("colCursos").where("idCiclo", "==", idCiclo).get().then(snapshot => {
            const arrayCursos = snapshot.docs.map(doc => {
                let data = doc.data();
                let id = doc.id;
                return { id, ...data };
            });
            setCursos(arrayCursos);

        });
    }


    return (

        <Container style={style.cardGrid}>
            <Paper style={style.paper}>
                <Grid item xs={4} sm={12}>
                    <Breadcrumbs aria-label="breadcrumbs">
                        <Link to="/ciclos"
                            color="inherit"
                            style={style.link}
                        >
                            <ArrowBackIosIcon />
                                Ciclos
                            </Link>
                        <Typography color="textPrimary">Cursos</Typography>
                    </Breadcrumbs>
                </Grid>
                {/* <Grid item xs={12} sm={12} style={style.gridTextfield}>
                    <Grid container spacing={4}>
                        {cursos.map((curso, index) => (
                            <CompCurso
                                key={curso.id}
                                curso={curso}
                                index={index + 1}
                            />
                        ))}
                    </Grid>
                </Grid> */}
                <Grid item xs={12} sm={12} style={style.gridTextfield}>
                <Grid container spacing={4} justify={'center'}>
                {cursos.map((item, index) => (
                    <CompCursoItem
                        key={item.id}
                        item={item}
                        index={index + 1}
                    />
                ))}
                </Grid>
                </Grid>
            </Paper>
        </Container>
    )
}

export default withRouter(PagListaCursos)
